import BRONZE_EMBLEM from "../../../assets/icon/ranks/BronzeEmblem.svg";
import DIAMOND_EMBLEM from "../../../assets/icon/ranks/DiamondEmblem.svg";
import EMERALD_EMBLEM from "../../../assets/icon/ranks/EmeraldEmblem.svg";
import GOLD_EMBLEM from "../../../assets/icon/ranks/GoldEmblem.svg";
import IRON_EMBLEM from "../../../assets/icon/ranks/IronEmblem.svg";
import PLATINUM_EMBLEM from "../../../assets/icon/ranks/PlatinumEmblem.svg";
import SILVER_EMBLEM from "../../../assets/icon/ranks/SilverEmblem.svg";
import BRONZE from "../../../assets/icon/ranks/bronze.svg";
import DIAMOND from "../../../assets/icon/ranks/diamond.svg";
import EMERALD from "../../../assets/icon/ranks/emerald.svg";
import GOLD from "../../../assets/icon/ranks/gold.svg";
import IRON from "../../../assets/icon/ranks/iron.svg";
import PLATINUM from "../../../assets/icon/ranks/platinum.svg";
import SILVER from "../../../assets/icon/ranks/silver.svg";
import UNRANKED from "../../../assets/icon/ranks/unranked.svg";

class CRank {
  public static IRON = "Iron";
  public static BRONZE = "Bronze";
  public static SILVER = "Silver";
  public static GOLD = "Gold";
  public static PLATINUM = "Platinum";
  public static EMERALD = "Emerald";
  public static DIAMOND = "Diamond";
  public static UNRANKED = "Unranked";

  public icon: string;
  public emblem: string;
  public color: string;

  public rank: string;
  public subRank: number | undefined;
  public lp: number | undefined;

  public static variants = {
    [CRank.IRON]: {
      icon: IRON,
      emblem: IRON_EMBLEM,
      color: "#915842",
    },
    [CRank.BRONZE]: {
      icon: BRONZE,
      emblem: BRONZE_EMBLEM,
      color: "#e7a187",
    },
    [CRank.SILVER]: {
      icon: SILVER,
      emblem: SILVER_EMBLEM,
      color: "#0062ff",
    },
    [CRank.GOLD]: {
      icon: GOLD,
      emblem: GOLD_EMBLEM,
      color: "#FFCC00",
    },
    [CRank.PLATINUM]: {
      icon: PLATINUM,
      emblem: PLATINUM_EMBLEM,
      color: "#0084FF",
    },
    [CRank.EMERALD]: {
      icon: EMERALD,
      emblem: EMERALD_EMBLEM,
      color: "#2aff6a",
    },
    [CRank.DIAMOND]: {
      icon: DIAMOND,
      emblem: DIAMOND_EMBLEM,
      color: "#31b9d9",
    },
    [CRank.UNRANKED]: {
      icon: UNRANKED,
      emblem: UNRANKED,
      color: "#000000",
    },
  };

  constructor({
    rank,
    subRank,
    lp,
  }: {
    rank: string;
    subRank: number | undefined;
    lp: number | undefined;
  }) {
    const { color, icon, emblem } = CRank.variants[rank];

    this.color = color;
    this.emblem = emblem;
    this.icon = icon;

    this.rank = rank.toLowerCase();
    this.subRank = subRank;
    this.lp = lp;
  }
}

export default CRank;
